// Runtime configuration from window._env_ (injected at container startup)
export async function configs() {
    const env = window._env_ || {};

    return {
        environment: env.ENVIRONMENT,
        userBaseUrl: env.USER_BASE_URL,
        merchantConfigurationBaseUri: env.MERCHANT_CONFIGURATION_BASE_URI,
        merchantInvitesEndpoint: env.MERCHANT_INVITES_ENDPOINT,
        partnersEndpoint: env.PARTNERS_ENDPOINT
    };
}
export default configs;
